import { Component, Input, OnInit, OnDestroy , ElementRef , ViewChild , ChangeDetectorRef, NgZone} from '@angular/core';
import { StudentMessagingService } from '@student/core/messaging/student-messaging.service';



@Component({
        standalone: false,
        selector:       "tanzeel-notification-comp" ,
        templateUrl:    "./tanzeel.notification.comp.html",
        styleUrls :     ["./tanzeel.notification.comp.css"]
  })

export class TanzeelNotificationComp implements OnInit, OnDestroy {

    tanzeel:any = window["DATA"];
	hidden:boolean = true;
	code:string;
    buttonMessage:string = "close";
	message:string = "";
    messageTitle:string = null;
    messagehtml:any=null;
    type:number = 1;
    // 1 is for info
    // 2 is for warning
    // 3 is error
    // 4 is for confirmation
	private dismissTimer: number | null = null;

	constructor(
		private mms: StudentMessagingService,
		private changeDRef: ChangeDetectorRef,
		private ngZone: NgZone,
	) {
	}
	
	ngOnInit(): void {
        this.mms.nts = this;
	}
	
	ngOnDestroy(): void {
		this.clearDismissTimer();
	}

	private clearDismissTimer(): void {
		if (this.dismissTimer != null) {
			clearTimeout(this.dismissTimer);
			this.dismissTimer = null;
		}
	}

	close(){
        this.clearDismissTimer();
        this.hidden = true;
        this.messageTitle = null;
        this.message = null;
        this.type = 1;
        this.messagehtml = null;
        this.changeDRef.detectChanges();
    }
    
    getImage():string{
        let url:string = "";//this.tanzeel.contextPath.toString();
        if( this.type == 1){
            url  = url + "assets/images/checked.svg";
        }
        else if( this.type == 2){
            url  = url + "assets/images/flash.svg";
        }
        else if( this.type == 3){
            url  = url + "assets/images/stop.svg";
        }
        return url;
    }

    getMessage():string {
        return this.message;
    }
    getMessageType():string{
        var msg = "";
        if( this.type == 1){
            msg = "Success";
        }
        else if( this.type == 2){
            msg  = "Warning";
        }
        else if( this.type == 3){
            msg  = "Unsuccessfull";
        }
        else if( this.type == 4 ){
            msg  = "Confirmation";
        }
        return msg;
    }

    closeTimeout:number = 6;
    closeAfterSeconds( seconds:number ){
        this.clearDismissTimer();
        this.dismissTimer = window.setTimeout(() => {
            this.ngZone.run(() => this.close());
        }, seconds * 1000);
    }

    private showNotification(): void {
        this.hidden = false;
        this.changeDRef.detectChanges();
    }

    info( title:string , message:string , timeout?:number ){
        this.messageTitle = title;
        this.message = message;
        this.type = 1;
        this.showNotification();
        if( timeout == undefined )
            this.closeAfterSeconds( this.closeTimeout );
        else 
            this.closeAfterSeconds( timeout );
    }

    infohtml( title:string , message:string , timeout?:number ){
        this.messageTitle = title;
        this.messagehtml = message;
        this.type = 1;
        this.showNotification();
        if( timeout == undefined )
            this.closeAfterSeconds( this.closeTimeout );
        else 
            this.closeAfterSeconds( timeout );
    }

    confirmation( title:string , message:string , timeout?:number){
        this.messageTitle = title;
        this.message = message;
        this.type = 4;
        this.showNotification();
        if( timeout == undefined )
            this.closeAfterSeconds( this.closeTimeout );
        else 
            this.closeAfterSeconds( timeout );
    }

    warning( title:string , message:string , timeout?:number){
        this.messageTitle = title;
        this.message = message;
        this.type = 2;
        this.showNotification();

        if( timeout == undefined )
            this.closeAfterSeconds( this.closeTimeout );
        else 
            this.closeAfterSeconds( timeout );
    }

    error( title:string , message:string , timeout?:number){
        this.messageTitle = title;
        this.message = message;
        this.type = 3;
        this.showNotification();
        if( timeout == undefined )
            this.closeAfterSeconds( this.closeTimeout );
        else 
            this.closeAfterSeconds( timeout );
    }
}
